export const lossesZeroTransform = (value: number | undefined) => {
  if (!value) {
    return 0;
  }

  if (value === 0) {
    return '0';
  }

  return '-' + value;
};
